import React from 'react';
import { Row, Col, Button } from 'antd';
import { connect } from 'dva';

@connect(({ operationChargeItemPublishChargeItemSteps, loading }) => ({
  selectedRows: operationChargeItemPublishChargeItemSteps.selectedRows,
  selectedRowKeys: operationChargeItemPublishChargeItemSteps.selectedRowKeys,
  validateResult: operationChargeItemPublishChargeItemSteps.validateResult,
  loading: loading.effects['operationChargeItemPublishChargeItemSteps/validatePublish'],
}))
export default class OperationButtons extends React.Component {
  constructor(props) {
    super(props);

    this.handlePrevStep = this.handlePrevStep.bind(this);
    this.handleNextStep = this.handleNextStep.bind(this);
  }

  handlePrevStep() {
    this.props.dispatch({ type: 'operationChargeItemPublishChargeItemSteps/decrementCurrentStep' });
  }

  handleNextStep() {
    this.props
      .dispatch({
        type: 'operationChargeItemPublishChargeItemSteps/validatePublish',
        ids: this.props.selectedRowKeys,
      })
      .then(valid => {
        if (valid) {
          this.props.dispatch({
            type: 'operationChargeItemPublishChargeItemSteps/incrementCurrentStep',
          });
        }
      });
  }

  render() {
    const { selectedRows, validateResult, loading } = this.props;

    return (
      <Row className="operation-button-wrap">
        {validateResult.valid === false && (
          <Col span={24} className="error-msg">
            {validateResult.message}
          </Col>
        )}
        <Col span={24}>
          <Button onClick={this.handlePrevStep}>上一步</Button>
          <Button
            type="primary"
            onClick={this.handleNextStep}
            disabled={selectedRows.length === 0}
            loading={loading}
          >
            下一步
          </Button>
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Operation/ChargeItem/PublishChargeItemSteps/Step1/OperationButtons.js